<template>
  <el-button type="success" circle  size="mini">
      <i class="el-icon-refresh-right" @click="refresh"></i>
  </el-button>
  <!-- <i class="el-icon-refresh-right" @click="refresh"></i> -->
</template>
<script>
export default {
  name: "ReturnBtn",
  props: ["refresh"],
  data() {
    return {};
  }
};
</script>